/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


///// ITG Code Start


const updateDataMax = () => {
    const productMainElements = document.querySelectorAll('.itg-product-main');
    productMainElements.forEach(function (productMain) {
      const inputOrSelect = productMain.querySelector('[name="id"]');
      const qtyInput = productMain.querySelector('input[name="quantity"]');
      if (!inputOrSelect || !qtyInput) return;
      let selectedElement;
      if (inputOrSelect.tagName.toLowerCase() === 'select') {
        selectedElement = inputOrSelect.options[inputOrSelect.selectedIndex];
      } else {
        selectedElement = inputOrSelect;
      }
      const inventory = parseInt(selectedElement.getAttribute('data-inventory') || 0, 10);
      const wholesale = document.body.getAttribute('data-wholesale');
      let innerQty = parseInt(selectedElement.getAttribute('data-product-inner-qty') || 1, 10);
      let masterQty = parseInt(selectedElement.getAttribute('data-product-master-qty') || 1, 10);


      innerQty = innerQty === 0 ? 0 : innerQty;
      masterQty = masterQty === 0 ? 0 : masterQty;
      
      let divisor = 1;

      var inputOne = document.querySelector("#item_quantity_type");
      var inputTwo = document.querySelector("#item_quantity_value");
      var inputThree = document.querySelector("#ea_quantity");
      var inputFour = document.querySelector("#totalPriceCalc");
      
      if (wholesale === 'Wholesale') {
        innerQty = innerQty === 0 ? 0 : innerQty;
        qtyInput.value = 1;
        if (innerQty === 0) {
          innerQty = innerQty === 0 ? masterQty : innerQty;
          inputOne.value = "masterQty";
          inputTwo.value = innerQty;
        } else {
          inputOne.value = "innerQty";
          inputTwo.value = innerQty;
        }
        divisor = innerQty;
        inputThree.value = Number(innerQty * document.querySelector('.quantity-selector--product .quantity-selector__value[name="quantity"]').value);
        calcPerItemPrice (innerQty);
      } else if (wholesale === 'B2B') {
        masterQty = masterQty === 0 ? 0 : masterQty;
        qtyInput.value = 1;
        divisor = masterQty;
        inputOne.value = "masterQty";
        inputTwo.value = masterQty;
        inputThree.value = Number(masterQty * document.querySelector('.quantity-selector--product .quantity-selector__value[name="quantity"]').value);
        calcPerItemPrice (masterQty);
      } else {
        divisor = 1; // Retail Customer
          inputOne.value = "retail";
          inputTwo.value = 1;
          inputThree.value = 1;
          calcPerItemPrice (1);
      }      
      const maxAdd = Math.floor(inventory / divisor);
      const remainder = inventory % divisor;
      qtyInput.setAttribute('data-max-add', maxAdd);
  
      const addButton = document.querySelector('.product-form__add-button.button.button--primary');
        if (addButton) {
          if (maxAdd === 0) {
            addButton.setAttribute('disabled', 'disabled');
            addButton.classList.add('disabled'); // Optional: for styling
          } else {
            addButton.removeAttribute('disabled');
            addButton.classList.remove('disabled'); // Optional: remove styling
          }
          setTimeout(() => {
              if (maxAdd === 0) {
                addButton.setAttribute('disabled', 'disabled');
                addButton.classList.add('disabled'); // Optional: for styling
              } else {
                addButton.removeAttribute('disabled');
                addButton.classList.remove('disabled'); // Optional: remove styling
              }
          },1000);
        }
    });
    document.querySelectorAll('.itg-product-main input[name="quantity"]').forEach((qtyInput) => {
      const parentForm = qtyInput.closest('.product-form');
      const quantityWrapper = qtyInput.closest('.quantity-selector.quantity-selector--product');
      if (!parentForm) return;
      let errorMsg = document.createElement('span');
      errorMsg.className = 'quantity-error-message';
      errorMsg.style.color = 'red';
      errorMsg.style.fontSize = '0.875rem'; // Tailwind: text-sm
      errorMsg.style.display = 'none';
      errorMsg.style.marginTop = '4px';
      quantityWrapper.parentNode.insertBefore(errorMsg, quantityWrapper.nextSibling);
      const checkQtyLimit = () => {
        const max = parseInt(qtyInput.getAttribute('data-max-add') || '9999', 10);
        const current = parseInt(qtyInput.value || 1, 10);
        if (current > max) {
          qtyInput.value = max;
          errorMsg.textContent = `You can only add up to ${max} item${max > 1 ? 's' : ''} for this product.`;
          errorMsg.style.display = 'block';
        } else {
          errorMsg.style.display = 'none';
        }
        if (current < 1) {
          qtyInput.value = 1;
        }
      };
      ['change', 'input', 'keyup', 'focusout'].forEach(eventName => {
        qtyInput.addEventListener(eventName, () => {
          setTimeout(checkQtyLimit, 0);
        });
      });
      parentForm.addEventListener('click', (e) => {
        const isBtn = e.target.matches('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]');
        if (isBtn) {
          setTimeout(checkQtyLimit, 0);
        }
      });
    });
}





function updateEaQuantityInCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        const properties = item.properties || {};
        const quantity = item.quantity;
        const quantityValue = parseInt(properties['_quantity_value'], 10);

        if (!isNaN(quantityValue)) {
          const eaQty = quantity * quantityValue;
          // const eaText = `${quantity} * ${quantityValue} = ${eaQty}`;
          const eaText = `${eaQty}`;

          // Only update if the existing _ea_quantity is different
          if (properties['_ea_quantity'] !== eaText) {
            // Add to updates object
            updates[item.id] = {
              ...properties,
              '_ea_quantity': eaText,
              '_totalPriceCalc': (eaQty * Number(item.price)) / 100.00
              //'_perPriceCalc': (eaQty * Number(item.price) / item.quantity) / 100.00
            };
          }
        }
      });

      // Loop through updates and POST to update line item properties
      Object.keys(updates).forEach(itemId => {
        const updatedProps = updates[itemId];

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: itemId,
            quantity: cart.items.find(item => item.id == itemId).quantity,
            properties: updatedProps
          })
        })
        .then(res => res.json())
        .then(data => {
        })
        .catch(err => console.error(`Error updating item ${itemId}`, err));
      });

    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}



const miniCartCustomQty2 = () => {
  let checkLineItemMiniOrCart = document.querySelectorAll('.mini-cart__line-item');
  if (checkLineItemMiniOrCart.length === 0) {
    checkLineItemMiniOrCart = document.querySelectorAll('.template-cart .line-item-table .line-item');
  }
  checkLineItemMiniOrCart.forEach((item) => {
    if (!item) return;
    const quantitySelector = item.querySelectorAll('.quantity-selector'); // Find all quantity selectors
    quantitySelector.forEach((selector) => {
      selector.classList.add("activeAdded");
      const input = selector.querySelector('input.quantity-selector__value');
      const increaseBtn = selector.querySelector('[data-action="increase-quantity"]');
      const decreaseBtn = selector.querySelector('[data-action="decrease-quantity"]');
      const quantityWrapper = input.closest('.quantity-selector');
      const wholesale = item.dataset.wholesale; // now get real text like "Wholesale Customer"
      const displayQty = parseInt(item.dataset.productDisplayQty, 10) || 0;
      let innerQty = parseInt(item.dataset.productInnerQty, 10) || 1;
      let masterQty = parseInt(item.dataset.productMasterQty, 10) || 1;
      const inventoryQty = parseInt(item.dataset.inventory, 10) || 1;

    innerQty = innerQty === 0 ? 1 : innerQty;
    // innerQty = innerQty === 0 ? masterQty === 0 ? 1 : masterQty : innerQty;
      
    masterQty = masterQty === 0 ? 1 : masterQty;
      let maxQty;      
      if (wholesale === 'Wholesale') { // ( Wholesale - Customers those have company and catalog )
        
        ///input.setAttribute('data-wholesale-step', innerQty);
        maxQty = Math.floor(inventoryQty / innerQty);
        
      } else if (wholesale === 'B2B') {   // ( B2B - Customers those have company but no catalog )
        
        //input.setAttribute('data-wholesale-step', masterQty);
        maxQty = Math.floor(inventoryQty / masterQty);
        
      } else { // ( Retail - Customers without company and catalog )
        maxQty = inventoryQty; // For Retail customers
      }
      input.setAttribute('data-max', maxQty);
      
      if (input.value >= maxQty) {
        input.value = maxQty;
      }
    });
  });

  updateEaQuantityInCart();

  
}
setTimeout (() => {
  updateDataMax();
}, 2000);
setTimeout (() => {
  miniCartCustomQty2();
  document.querySelectorAll('.quantity-selector[style*="pointer-event"]').forEach(el => {
              el.removeAttribute("style");
          });
}, 4000);


// const customerEmail = "order.itgeeks@gmail.com"; // Company + Catelog
// const customerEmail = "valu046@valuhc.com"; // Company without Catelog
// const customerEmail = "rodriguezperez.526@outlook.com"; // Retails no Company no Catelog

const fetchCustomDetails = () => {
    const customerEmail = document.body.getAttribute("data-customer-email") || "nocustomerfound@gmail.com"; // Dynamic or hardcoded as per your page logic
    fetch('https://king-prawn-app-qaoee.ondigitalocean.app/check-customer.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: customerEmail })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Customer Type:', data);
      setTimeout (() => {
          let allWholesaleAttr = document.querySelectorAll('[data-wholesale]');      
            if (data.type.includes('Wholesale Customer')) {
              allWholesaleAttr.forEach((selector) => {
                selector.setAttribute('data-wholesale', "Wholesale");
                document.body.setAttribute('data-wholesale', "Wholesale");
              });
            } else if (data.type.includes('B2B Customer')) {
              allWholesaleAttr.forEach((selector) => {
                selector.setAttribute('data-wholesale', "B2B");
                document.body.setAttribute('data-wholesale', "B2B");
              });
            } else {
              allWholesaleAttr.forEach((selector) => {
                selector.setAttribute('data-wholesale', "Retail");
                document.body.setAttribute('data-wholesale', "Retail");
              });
            }
          updateDataMax();
        }, 500);
        setTimeout (() => {
          miniCartCustomQty2();
          document.querySelectorAll('.quantity-selector[style*="pointer-event"]').forEach(el => {
              el.removeAttribute("style");
          });
        }, 2000);
    })
    .catch(error => console.error('Error:', error));
}
setTimeout (() => {
    fetchCustomDetails();
});
window.addEventListener('DOMContentLoaded', function () {
  setTimeout (() => {
    fetchCustomDetails();
  },3000);
});


function calcPerItemPrice (qty) {
  var perPriceCalcElement = document.querySelector('.line-item-property__field #perPriceCalc');
  if (perPriceCalcElement) {
    var perPriceCalcValue = parseFloat(perPriceCalcElement.value); // Make sure to convert it to a number
    var calculatedPrice = perPriceCalcValue * qty;
    document.querySelector('.line-item-property__field #perPriceCalc2').value = calculatedPrice.toFixed(2); // Set the calculated price back to the DOM element
    console.log('Calculated Price:', calculatedPrice + '  - ' + perPriceCalcElement.value);
  }
}

///// ITG Code End
// INSTANT Minimum Order Checker - ITG Integration (Main Cart Only)
function checkMinimumOrderInstant() {
  const minimumOrderElement = document.querySelector('[data-b2b-minimum-amount]');
  if (!minimumOrderElement) return;
  
  const minimumAmount = parseFloat(minimumOrderElement.getAttribute('data-b2b-minimum-amount')) || 0;
  if (minimumAmount <= 0) return;
  
  // Get cart total for main cart only
  if (window.theme && window.theme.cartCount > 0) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cartTotal = cart.total_price / 100;
        updateMinimumOrderDisplay(minimumAmount, cartTotal);
      })
      .catch(() => {
        // Fallback to DOM parsing if API fails
        const priceElement = document.querySelector('.cart-recap__price-line-price');
        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^0-9.,]/g, '');
          cartTotal = parseFloat(priceText) || 0;
          updateMinimumOrderDisplay(minimumAmount, cartTotal);
        }
      });
  }
}

function updateMinimumOrderDisplay(minimumAmount, cartTotal) {
  const shortfall = minimumAmount - cartTotal;
  
  // Update main cart only (mini-cart is now static)
  const mainCartWarning = document.getElementById('cart-minimum-order-warning');
  const mainCartCheckoutBtn = document.querySelector('.cart-recap__checkout');
  
  if (shortfall > 0) {
    // Disable main cart button
    if (mainCartCheckoutBtn) {
      mainCartCheckoutBtn.disabled = true;
      mainCartCheckoutBtn.style.opacity = '0.5';
      mainCartCheckoutBtn.style.cursor = 'not-allowed';
    }
  } else {
    // Enable main cart button
    if (mainCartCheckoutBtn) {
      mainCartCheckoutBtn.disabled = false;
      mainCartCheckoutBtn.style.opacity = '1';
      mainCartCheckoutBtn.style.cursor = 'pointer';
    }
  }
}

// Intercept checkout attempts for extra security (mainly for mini-cart)
function interceptCheckoutAttempts() {
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/cart') && form.querySelector('button[name="checkout"]')) {
      // Only intercept mini-cart submissions (main cart button is already disabled server-side)
      if (form.id === 'mini-cart') {
        const minimumOrderElement = document.querySelector('[data-b2b-minimum-amount]');
        if (!minimumOrderElement) return;
        
        const minimumAmount = parseFloat(minimumOrderElement.getAttribute('data-b2b-minimum-amount')) || 0;
        if (minimumAmount <= 0) return;
        
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartTotal = cart.total_price / 100;
            if (cartTotal < minimumAmount) {
              e.preventDefault();
              const shortfall = minimumAmount - cartTotal;
              alert(`Minimum order of $${minimumAmount.toFixed(2)} required. Please add $${shortfall.toFixed(2)} more to your cart.`);
              return false;
            }
          })
          .catch(() => {
            // If API fails, let the form submit and let server-side handle it
          });
      }
    }
  });
}

// Hook into ITG's completion points (keep existing logic for dynamic updates)
const originalUpdateEaQuantity = window.updateEaQuantityInCart;
if (originalUpdateEaQuantity) {
  window.updateEaQuantityInCart = function() {
    const result = originalUpdateEaQuantity.apply(this, arguments);
    // Quick check after ITG completes
    setTimeout(checkMinimumOrderInstant, 100);
    return result;
  };
}

// Instant checks on page events
document.addEventListener('DOMContentLoaded', function() {
  checkMinimumOrderInstant();
  interceptCheckoutAttempts();
});

// Quick check on cart changes
document.addEventListener('cart:rerendered', function() {
  setTimeout(checkMinimumOrderInstant, 50);
});

// Check when quantities change
document.addEventListener('change', function(e) {
  if (e.target && e.target.classList.contains('quantity-selector__value')) {
    setTimeout(checkMinimumOrderInstant, 100);
  }
});